// Set this to localhost/IP for development and the production URL for deployment
const hostname = window.location.hostname;
const isLocal =
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname.startsWith('192.168.') ||
  hostname.startsWith('10.') ||
  hostname.startsWith('172.') ||
  hostname.endsWith('.local');

// For Netlify deployment, use relative path to Netlify Functions
// For local development, use REACT_APP_API_URL if defined, otherwise the same hostname on port 5001
const API_BASE_URL = process.env.REACT_APP_API_URL || (isLocal ? `http://${hostname}:5001` : '');

export default API_BASE_URL;
